export const LOADING_AUTH = 'LOADING_AUTH';
export const GET_TOKEN = 'GET_TOKEN';
export const GET_USERS = 'GET_USERS';
export const RESET_PASS = 'RESET_PASS';
export const RECOVER_PASS = 'RECOVER_PASS';
export const SAVE_lOADER_USER = 'SAVE_lOADER_USER';
export const GET_FORMAL_FICHA = 'GET_FORMAL_FICHA';
export const SAVE_LOADER_VERIFICATION = 'SAVE_LOADER_VERIFICATION';
export const LOADING_VERIFICATION = 'LOADING_VERIFICATION';
export const GET_VERIFICATION = 'GET_VERIFICATION';
export const LOADER_RESET_PASS = 'LOADER_RESET_PASS';

export const FORM_FAIL = "FORM_FAIL";
export const USER_FAIL = "USER_FAIL";
export const FORM_PASSWORD_FAIL = "FORM_PASSWORD_FAIL";